import AuthenticationFailed from './AuthenticationFailed'
export default AuthenticationFailed
